import { createSelector } from "reselect";
import { tGovernanceData, tDocuments, tDocumentsList, tDirectors, tDirectorsList } from "../types";

const getState = (state) => state.governanceReducer.governance;

const governanceSelector = createSelector([getState], (item) => {

    let results: tGovernanceData;

    if (item) {


        let documents: tDocuments;
        let directors: tDirectors;


        const { attributes } = item;



        if (attributes && attributes.Documents) {

            let documentsList: tDocumentsList[] = [];
            if (attributes.Documents.Documents && attributes.Documents.Documents.length > 0) {
                attributes.Documents.Documents.forEach(doc => {
                    documentsList = [
                        ...documentsList,
                        {
                            id: doc.id,
                            title: doc.Title,
                            url: doc.Document && doc.Document.data && doc.Document.data.attributes && doc.Document.data.attributes.url && doc.Document.data.attributes.url,
                            format: doc.Format,
                        }
                    ];
                });
            }

            documents = {
                id: attributes.Documents.id,
                title: attributes.Documents.Title,
                preview: attributes.Documents.Preview,
                text: attributes.Documents.Text,
                documents: documentsList,
            }

        }

        if (attributes && attributes.Directors) {

            let direcotrsList: tDirectorsList[] = [];
            if (attributes.Directors.Directors && attributes.Directors.Directors.length > 0) {
                attributes.Directors.Directors.forEach(dir => {
                    direcotrsList = [
                        ...direcotrsList,
                        {
                            id: dir.id,
                            name: dir.Name,
                            position: dir.Position,
                            photo: dir.Photo && dir.Photo.data && dir.Photo.data.attributes && dir.Photo.data.attributes.url && dir.Photo.data.attributes.url,
                        }
                    ];
                });
            }

            directors = {
                id: attributes.Directors.id,
                title: attributes.Directors.Title,
                preview: attributes.Directors.Preview,
                text: attributes.Directors.Text,
                directors: direcotrsList,
            }

        }


        results = {
            id: item.id,
            title: attributes && attributes.Title,
            description: attributes && attributes.Description,
            image: attributes && attributes.Image && attributes.Image.data && attributes.Image.data.attributes && attributes.Image.data.attributes.url,
            documents,
            directors,
        }
    }

    return results;
});

export default governanceSelector;
